import { Component, OnInit } from '@angular/core';
import { FurService } from 'src/app/services/fur.service';
import { Fur } from 'src/app/models/Fur';
import { MatDialog } from '@angular/material/dialog';
import { NumIdTipCatCampPlantFW, RecupObjDatosPlant, saveContent2 } from 'src/app/general/variables';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { ParametroPlantillaDocumento, RecuperarGrillasPD } from 'src/app/general/Funciones';
import { General } from 'src/app/models/General';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { Observable } from 'rxjs/internal/Observable';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-antecedentes-fur',
  templateUrl: './antecedentes-fur.component.html',
  styleUrls: ['./antecedentes-fur.component.css']
})
export class AntecedentesFurComponent implements OnInit {

  listFormWeb: Fur[];
  fur: Fur = new Fur();
  generalPD: General = new General();

  constructor(protected furService: FurService,
              public dialog: MatDialog,
              protected parametroPlantillaDocumento: ParametroPlantillaDocumento,
              protected externosService: ExternosService,
              private spinner: NgxSpinnerService) {}

  ngOnInit() {

    this.parametroPlantillaDocumento.recupParamPlantillaDoc(14, NumIdTipCatCampPlantFW).subscribe(data => {

      this.generalPD = data;

    });

  }

  RecuperarAntecedentes(idFur: number) {

    this.listFormWeb = [];

    // console.log("============recuperar");



  }

  _descargarPdf() {

    // ;

    /////// ASI DEBE QUEDAR
    // window.open(RecupUrlOficio(this.fur.listaDocumentoAdjuntoDet), '_blank');
    /////// ASI DEBE QUEDAR

    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE
    // console.log(Number(this.strNroRegistro));
    this.spinner.show();

    this._generarPlantilla(this.fur.nfurId ).subscribe(data => {

      this.spinner.hide();

      // console.log("============1111data");
      // console.log(data);

      saveContent2(data.dscCampo1, 'OficioFW.pdf');

    });
    // PROVISIONAL HASTA QUE FUNCIONE EL LASERFICHE

    // var vPlantillaDocumento:PlantillaDocumento = new PlantillaDocumento();
    // var vDscNomFile = "wordGeneradoCGR.docx";

    // //vPlantillaDocumento.datos = this.pdDatos;

    // vPlantillaDocumento.datos = [];
    // vPlantillaDocumento.datos[0] = new PDDatos();
    // vPlantillaDocumento.datos[0].campo = "campo";
    // vPlantillaDocumento.datos[0].nombre = "nombre";
    // vPlantillaDocumento.datos[0].valor = "valor";


    // vPlantillaDocumento.nombreArchivoPlantilla = "WORDCGR.DOCX";
    // vPlantillaDocumento.rutaArchivoGenerado = "C:/archivos/";

    // vPlantillaDocumento.nombreArchivoGenerado = vDscNomFile ;

    // this.spinner.show();

    // this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
    //   data => {

    //     this.spinner.hide();

    //     saveContent(data.base64, vDscNomFile );

    //   },
    //   err =>{

    //     this.spinner.hide();

    //     console.log(err);

    //   });

    // //this._generarPlantilla();


  }

  getAntecedenteFurC(): Fur {

    return this.listFormWeb[0];

  }

  _generarPlantilla(numIdFur: number) {

    // var vListGeneralFinal:General[] = [];
    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    let vFur: Fur = null;
    const vGeneralReturn: General = new General();

    // flgProcLF = (flgProcLF == null ? true : false);

    vPlantillaDocumento.datos = [];
    // vPlantillaDocumento.tabla = [];

    const plantillaObservable = new Observable<General>(observer => {

      // OBTENGO LOS ULTIMOS DATOS

      this.furService.ObtenerPlantillaFurPorId(numIdFur).subscribe(
        data => {

          vFur = data;

          this.generalPD.listaPdDatos = RecupObjDatosPlant(vFur, this.generalPD.listaPdDatos);

          vPlantillaDocumento.nombreArchivoPlantilla = this.generalPD.dscCampo1;
          vPlantillaDocumento.nombreArchivoGenerado = this.generalPD.dscCampo2;
          vPlantillaDocumento.datos = this.generalPD.listaPdDatos;

          vPlantillaDocumento.grillas = RecuperarGrillasPD('6', vFur.listaDenunciadoPorFicha, 4); // DENUNCIADOS

          vPlantillaDocumento.grillas = RecuperarGrillasPD('10', vFur.listaDocumentoAdjuntoDet, 1, vPlantillaDocumento.grillas); // EVIDENCIAS

          vPlantillaDocumento.grillas = RecuperarGrillasPD('12', vFur.listaFichaPorInstancia, 5, vPlantillaDocumento.grillas); // instancias

          console.log('===============vPlantillaDocumento');
          console.log(JSON.stringify(vPlantillaDocumento));

          this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
            data => {

              vGeneralReturn.dscCampo1 = data.base64;
              vGeneralReturn.flgCampo1 = true;

              observer.next(vGeneralReturn);


            },
            err => {


              console.log(err);

            });

        });

    });

    return plantillaObservable;

  }


  _VerAntecedente() {

    this._descargarPdf();

    // LA DESCARGA DEBE SER A PRTIR DE UN SERVICIO RETORNE EL BASE 64 A PARTIR DE UNA URL

    // var vOficio:DocumentoDet =  this.listFormWeb[0].listaDocumentoAdjuntoDet.find(x=>x.cdocumentoCodsubtipo == CodSubTipoFichaOFI);

    // vOficio.cdocumentoDscurl;

    // saveContent();


  }

}
